var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "sidebar-container" },
        [
          _c("div", { staticClass: "sidebar-cover" }),
          _vm._v(" "),
          _c("sidebar"),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("main-map"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mobile-info-block" }, [
      _c("h1", [_vm._v("MPA Reality Check")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }